/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:object_id/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdUsers } from "./constants";
import type { CustomObjectsTypeNameObjectIdUsersParams, CustomObjectsTypeNameObjectIdUsersResult } from "./types";
import { isCustomObjectsTypeNameObjectIdUsersResult } from "./validators";

export const getDataTableCustomObjectsTypeNameObjectIdUsers = reactQueryTableFetcherAdapter(
  customObjectsTypeNameObjectIdUsers,
  (
    signal: AbortSignal,
    { appGroupId, typeName, objectId, limit = 12, start = 0, user_id }: CustomObjectsTypeNameObjectIdUsersParams
  ): Promise<CustomObjectsTypeNameObjectIdUsersResult> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/users`,
      "GET",
      {
        app_group_id: appGroupId,
        limit,
        start,
        user_id,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isCustomObjectsTypeNameObjectIdUsersResult
);
